An opaque cursor to the earlier bounding page.

Resulting position openings will _succeed_ this cursor.
